<app-sub-panel [title]="fieldName" [className]="className"  [isRequired]="isRequired">
    <div action>
        <span nz-icon (click)="addTester()" nzType="plus" nzTheme="outline" class="add-icon" nz-tooltip
            nzTooltipTitle="Add Tester"></span>
    </div>
    <div content>
        <ng-container *ngIf="(!isEditing && currentValue.length === 0) || (currentValue.length === 0 && !clickToEdit); else contentTemp">
            <div class="display-area" (click)="addTester()">
                <span class="empty-content">Add testers ...</span>
            </div>
        </ng-container>
        <ng-template #contentTemp>
            <div class="tester-item" *ngFor="let testerItem of currentValue; let i = index">
                <div class="tester-name">
                    <div *ngIf="!isEditing" (click)="startEdit()" class="click-to-edit-area">
                        <app-avatar
                                [info]="{ name: accountData[testerItem.testerId]?.fullNameWithEmail, avatar: accountData[testerItem.testerId]?.avatar }"
                                [size]="24" class="avatar-icon" [enable]="isMemberActive(testerItem?.testerId)"></app-avatar>
                        {{ isMemberActive(testerItem?.testerId) ? accountData[testerItem.testerId]?.fullName : accountData[testerItem.testerId]?.fullName + ' (Inactive)'}}
                    </div>
                    <nz-select *ngIf="isEditing" #selectComponent [(ngModel)]="testerItem.testerId" nzShowSearch
                               [nzAllowClear]="true" style="width: 100%" (ngModelChange)="changeTester()" [nzStatus]="isMemberActive(testerItem?.testerId) ? '' : 'error'"
                               class="tester-select">
                        <nz-option *ngFor="let option of testerOptions" [nzValue]="option.value" [nzLabel]="option.label"
                                   [nzDisabled]="isNotSelected(option.value, testerItem.testerId)"></nz-option>
                    </nz-select>
                </div>
                <div class="row-right">
                    <div class="tester-times">
                        <div class="time-item" *ngFor="let item of testerItem.timeIntervals; let j = index">
                            <ng-container *ngIf="isEditing">
                                <nz-date-picker class="time-select" [nzPlaceHolder]="dateDefault"
                                                [nzShowTime]="{ nzFormat: 'h a', nzHideSeconds: true, nzUse12Hours: true }"
                                                nzFormat="yyyy-MM-dd h a" [(ngModel)]="item.startDate"
                                                (ngModelChange)="getUpdatedDateRange()" [disabled]="!isMemberActive(testerItem?.testerId)"
                                ></nz-date-picker>
                                <nz-date-picker class="time-select" [nzPlaceHolder]="dateDefault"
                                                [nzShowTime]="{ nzFormat: 'h a', nzHideSeconds: true, nzUse12Hours: true }"
                                                nzFormat="yyyy-MM-dd h a" [(ngModel)]="item.endDate"
                                                (ngModelChange)="getUpdatedDateRange()" [disabled]="!isMemberActive(testerItem?.testerId)"
                                ></nz-date-picker>
                                <div class="action">
                                    <i *ngIf="testerItem.timeIntervals.length > 1" nz-icon nzType="minus-circle-o"
                                       class="time-icon" nz-tooltip="Remove booking time" (click)="isMemberActive(testerItem?.testerId) && removeTime(i, j)"
                                       [ngClass]="!isMemberActive(testerItem?.testerId) ? 'icon-disabled' : ''"></i>
                                    <i nz-icon nzType="plus-circle" class="time-icon" nz-tooltip="Add booking time"
                                       (click)="isMemberActive(testerItem?.testerId) && addTime(i, j)"
                                       [ngClass]="!isMemberActive(testerItem?.testerId) ? 'icon-disabled' : ''"></i>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!isEditing">
                                <div class="click-to-edit-area time-select" (click)="startEdit()">
                                    <span>{{ item.startDate | date: "YYYY-MM-dd h a" }}</span>
                                </div>
                                <div class="click-to-edit-area time-select" (click)="startEdit()">
                                    <span>{{ item.endDate | date: "YYYY-MM-dd h a" }}</span>
                                </div>
                            </ng-container>

                        </div>
                    </div>
                    <button *ngIf="isEditing" nz-button nzDanger nz-tooltip="Unassign" class="remove-row"
                            (click)="removeRow(i); $event.stopPropagation();">
                        <i nz-icon nzType="usergroup-delete" nzTheme="outline"></i>
                    </button>
                </div>
            </div>
            <div *ngIf="showGantt" class="gantt-panel">
                <ngx-gantt #gantt
                           [maxLevel]="2"
                           [async]="true"
                           [virtualScrollEnabled]="false"
                           [loadingDelay]="300"
                           [items]="items"
                           [viewType]="viewType"
                           [showTodayLine]="true"
                           [viewOptions]="viewOptions"
                           [ngClass]="anyInactiveMembers() ? 'inactive-members' : ''"
                           style="height: 400px; display: block;">
                    <ngx-gantt-table>
                        <ng-template #bar let-bar='item'>
                            <div nz-tooltip [nzTooltipTitle]="bar.title" [nzTooltipPlacement]="'topLeft'"
                                 [nzTooltipColor]="'orange'"
                                 style="color: #fff; white-space: nowrap; padding-left: 5px; overflow: hidden; text-overflow: ellipsis;">
                                {{ bar.title }}
                            </div>
                        </ng-template>
                        <ngx-gantt-column [name]="'Users'" [width]="200">
                            <ng-template #cell let-item="item">
                                <ng-container *ngIf="item.title != 'Load More'; else loadMoreTemplate">
                                    <div class="gantt-item-title" nz-tooltip [nzTooltipTitle]="item.title"
                                         [nzTooltipPlacement]="'topRight'"
                                         style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                        {{ isMemberActive(item.id) ? item.title : item.title + ' (Inactive)' }}
                                    </div>
                                </ng-container>
                                <ng-template #loadMoreTemplate>
                                    <ng-container *ngIf="showLoadMore(item.id)">
                                        <button nz-button class="load-more-btn" (click)="loadMoreChild(item.id)">Load
                                            More
                                        </button>
                                    </ng-container>
                                </ng-template>
                            </ng-template>
                        </ngx-gantt-column>
                    </ngx-gantt-table>
                </ngx-gantt>
            </div>
            <div class="action-group" *ngIf="isEditing && clickToEdit">
                <button nz-button nzType="primary" class="action-item" (click)="handleSave()"
                        [nzLoading]="saveLoading">Save</button>
                <button nz-button nzDanger class="action-item" (click)="handleCancel()">Cancel</button>
            </div>
        </ng-template>
    </div>
</app-sub-panel>
